import { ApiError } from '../../../core/errors'
import { HttpRequest } from '../../../core/interfaces/http'
import { ErrorCategory } from '../../../core/interfaces/error/ErrorCategory.Enum'

/**
 * This error occurs if a response received from the jsonrpc server doesn't
 * conform to the JsonRPC spec.
 */
export class MalformedJsonRpcResponseError extends ApiError {
  public readonly rpcResponse: unknown

  /**
   *
   * @param args
   */
  constructor(args: {
    message: string;
    httpRequest: HttpRequest;
    rpcResponse: unknown; // the raw malformed json rpc response
  }) {
    const myMessage = `Malformed JsonRpc response (the server gave an out-of-specs response).
    ${args.message}.`
    super({
      ...args,
      message: myMessage,
      code: 'malformed-json-rpc-response',
      category: ErrorCategory.RESPONSE_PROBLEM,
      excerptExtra: { 'rpc-reponse': args.rpcResponse },
    })
    Object.setPrototypeOf(this, MalformedJsonRpcResponseError.prototype)
    this.rpcResponse = args.rpcResponse
  }

  public toJSON() {
    return JSON.stringify({
      ...this.getBaseJSON(),
      jsonRpc: {
        request: this.httpRequest.data,
        response: this.rpcResponse,
      },
    })
  }
}
